<div [formGroup]="filterForm" class="d-flex justify-content-start align-items-center">
    <div class="mr-s">
        <ng-content></ng-content>
    </div>
    <div class="mr-s" *ngIf="!clientsFilter">
        <app-favorite-input formControlName="favorite" color="white"></app-favorite-input>
    </div>

    <div class="min-width" class="mr-s">
        <app-form-group icon="icon-search" iconPosition="right" [clear]="true">
            <label translate>SEARCH</label>
            <input app-form
                   name="search"
                   type="text"
                   [value]="value('search')"
                   formControlName="search"/>
        </app-form-group>
    </div>
    <div class="min-width flex-grow-1">
        <app-select-input
                [multiple]="true"
                [max]="2"
                formControlName="group"
                [items]="groups$|async"
                [value]="value('group')"
                bindLabel="name"
                bindValue="{{clientsFilter ? 'id' : null}}"
                [searchable]="true"
        ><label translate>{{clientsFilter ? 'FILTER_BY_CLIENT' : 'FILTER_BY_GROUP'}}</label></app-select-input>
    </div>
</div>
